import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Typography } from "@material-ui/core";
import PopoverDisplay from "./PopoverDisplay";
import PopoverMenu from "./PopoverMenu";

export const InternalLink = ({ title, shouldDisplay }): React.ReactNode => {
  return (
    <div style={{ textDecoration: "none" }}>
      <Typography
        className={shouldDisplay ? "item-text-active" : "item-text"}
        color="primary"
        variant="body1"
      >
        <strong> {title}</strong>
      </Typography>
    </div>
  );
};

export const ExternalLink = ({ title, link }): React.ReactNode => {
  return (
    <a
      href={link}
      target="_blank"
      style={{ textDecoration: "none" }}
      className="site-pages"
    >
      <Typography className="item-text" color="primary" variant="body1">
        <strong>{title}</strong>
      </Typography>
    </a>
  );
};

const Item = ({
  type,
  pathname,
  popoverMenu,
  setOpenItem = () => {},
  openItem,
  title,
  ...other
}): React.ReactNode => {
  const [ref, setRef] = useState(null);
  const navigate = useHistory();

  const onMouseEnter = (e): void => {
    if (title !== openItem) {
      setOpenItem(title);
      if (popoverMenu !== null) {
        setRef(e?.currentTarget);
      }
    }
  };

  const onClick = (e): void => {
    onMouseEnter(e);
    navigate.push(other.link);
  };

  const onMouseLeave = (e): void => {
    setRef(null);

    setOpenItem(null);
  };
  const display = (): React.ReactNode => {
    if (type === "Internal") {
      return (
        <InternalLink
          activeLink={pathname}
          shouldDisplay={openItem === title}
          {...other}
          title={title}
        />
      );
    }
    return <ExternalLink {...other} title={title} />;
  };

  useEffect(() => {
    if (openItem !== title) {
      setRef(null);
    }
  }, [title, openItem]);

  return (
    <div className="flex-direction-column">
      <div className="item hoverable-component">
        <span
          onMouseEnter={onMouseEnter}
          onClick={onClick}
          aria-owns="mouse-over-popover"
          aria-haspopup="true"
          ref={ref}
        >
          {display()}
        </span>
      </div>

      <div
        style={{
          position: "fixed",
          top: 53,
          display: "flex",
          width: 100,
          justifyContent: "center",
        }}
      >
        <div
          className="arrow-up"
          style={{
            visibility:
              title === openItem && popoverMenu != null ? "visible" : "hidden",
          }}
        />
      </div>
      {popoverMenu && (
        <PopoverDisplay
          popoverEnter={onMouseEnter}
          popoverLeave={onMouseLeave}
          closePopover={onMouseLeave}
          anchorRef={ref}
          marginTop={20}
          popoverOpen={ref !== null && title === openItem}
        >
          <PopoverMenu menu={popoverMenu} />
        </PopoverDisplay>
      )}
    </div>
  );
};

export default Item;
